//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"ArrowSideOption",1,0],[0,"ExtendNewFace",1,0],[0,"ExtensionMethod",1,0],[1,"TargetCollector",0,"ScCollector",0],[1,"TargetExtendDistance",0,"Expression",0],[0,"TargetReversed",1,0],[0,"Tolerance",1,0],[1,"ToolCollector",0,"ScCollector",0],[1,"ToolExtendDistance",0,"Expression",0],[0,"ToolReversed",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.TrimExtendBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrimExtendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TrimExtendBuilder.CreationTypes = Object.freeze({
    "ByDistance" : "ByDistance", "PercentOfMeasured" : "PercentOfMeasured", "UntilSelected" : "UntilSelected", "MakeCorner" : "MakeCorner"});

SPLM.Features.TrimExtendBuilder.ExtensionMethods = Object.freeze({
    "NaturalCurvature" : "NaturalCurvature", "NaturalTangent" : "NaturalTangent", "Mirrored" : "Mirrored"});

SPLM.Features.TrimExtendBuilder.ArrowSideOptions = Object.freeze({
    "Retain" : "Retain", "Delete" : "Delete"});

export default SPLM;